// extracted by mini-css-extract-plugin
module.exports = {"Li":"Test_Li__A9ayh","Ul":"Test_Ul__2zYKr"};